import { type Ref, type MutableRefObject } from "react";

export function mergeRefs<T>(
  refs: Array<Ref<T> | undefined | null>,
): (instance: T | null) => void {
  return (instance: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === "function") {
        ref(instance);
      } else if (typeof ref === "object" && ref !== null) {
        (ref as MutableRefObject<T | null>).current = instance;
      }
    });
  };
}
